import styled from 'styled-components';
import { FONTS } from '@app/src/ui';

interface Props {
  active?: boolean;
  background?: string;
  isFixed?: boolean;
  isDisplay?: boolean;
  relative?: boolean;
}

export const Wrapper = styled.nav`
  font-family: ${FONTS.ROBOTO_BOLD};
  background: #fff;
  font-size: 14px;
  height: 100%;
  min-height: 50px;
  text-transform: uppercase;
  font-weight: 600;
  display: none;

  ${(props: Props) => props.isFixed ? `
    position: fixed;
    width: 100%;
    left: 0;
    height: 50px;
    top: 0;
    `
    : `
    position: static;
  `};

  @media (min-width: 920px ) {
    display: block;
  }
`;

export const Item = styled.a`
  color: #000;
  padding: 0 16px;
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;

  &:hover {
    background: rgb(0,0,0,.1)
  }

  &:hover ~ ul {
    display: block;
  }
`;

export const Main = styled.ul`
  display: flex;
  height: 100%;
`;

export const SubMain = styled.ul`
  position: absolute;
  z-index: 1;
  min-width: 200px;
  background: #fff;
  display: none;
  box-shadow: 2px 5px 6px rgb(0, 0, 0, .2);
  & > li {
    line-height: 32px;
  }

  &:hover {
    display: block;
  }
`;

export const IconExpand = styled.span`
  margin-left: 4px;
  display: inline-block;
  width: 12px;
  height: 12px;

  ${(props: LoggedProps) => props.isDisplay && `
    transform: rotate(180deg);
  `}
`;

const MAIN = 'NavBar';
Wrapper.displayName = `${MAIN}/Wrapper`;
Item.displayName = `${MAIN}/Item`;
